import { render, staticRenderFns } from "./addacaboutenoughsent.vue?vue&type=template&id=4f4b2694&"
import script from "./addacaboutenoughsent.vue?vue&type=script&lang=js&"
export * from "./addacaboutenoughsent.vue?vue&type=script&lang=js&"
import style0 from "./addacaboutenoughsent.vue?vue&type=style&index=0&id=4f4b2694&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports